// FORM
// API action types
export const FETCHING_STOCK_ADJUSTMENT_INFO = '@@toyota/FETCHING_STOCK_ADJUSTMENT_INFO';
export const FETCHED_STOCK_ADJUSTMENT_INFO = '@@toyota/FETCHED_STOCK_ADJUSTMENT_INFO';
export const FETCHED_STOCK_ADJUSTMENT_INFO_FAILED = '@@toyota/FETCHED_STOCK_ADJUSTMENT_INFO_FAILED';
export const CREATING_NEW_ADJUSTMENT = '@@toyota/CREATING_NEW_ADJUSTMENT';
export const CREATED_NEW_ADJUSTMENT = '@@toyota/CREATED_NEW_ADJUSTMENT';
export const CREATED_NEW_ADJUSTMENT_FAILED = '@@toyota/CREATED_NEW_ADJUSTMENT_FAILED';
export const PROCESSING_STOCK_ADJUSTMENT = '@@toyota/PROCESSING_STOCK_ADJUSTMENT';
export const PROCESSED_STOCK_ADJUSTMENT = '@@toyota/PROCESSED_STOCK_ADJUSTMENT';
export const PROCESSED_STOCK_ADJUSTMENT_FAILED = '@@toyota/PROCESSED_STOCK_ADJUSTMENT_FAILED';
export const ADDING_ADJUSTMENT_ITEM = '@@toyota/ADDING_ADJUSTMENT_ITEM';
export const ADDED_ADJUSTMENT_ITEM = '@@toyota/ADDED_ADJUSTMENT_ITEM';
export const ADDED_ADJUSTMENT_ITEM_FAILED = '@@toyota/ADDED_ADJUSTMENT_ITEM_FAILED';
export const REMOVING_ADJUSTMENT_ITEM = '@@toyota/REMOVING_ADJUSTMENT_ITEM';
export const REMOVED_ADJUSTMENT_ITEM = '@@toyota/REMOVED_ADJUSTMENT_ITEM';
export const REMOVED_ADJUSTMENT_ITEM_FAILED = '@@toyota/REMOVED_ADJUSTMENT_ITEM_FAILED';
export const UPDATING_STOCK_ADJUSTMENT_STATE = '@@toyota/UPDATING_STOCK_ADJUSTMENT_STATE';
export const UPDATED_STOCK_ADJUSTMENT_STATE = '@@toyota/UPDATED_STOCK_ADJUSTMENT_STATE';
export const UPDATED_STOCK_ADJUSTMENT_STATE_FAILED = '@@toyota/UPDATED_STOCK_ADJUSTMENT_STATE_FAILED';


export const CLEAR_ADJUSTMENT_INFO = '@@toyota/CLEAR_ADJUSTMENT_INFO';

// LIST
// API action types
export const FETCHING_STOCK_ADJUSTMENTS_LIST = '@@toyota/FETCHING_STOCK_ADJUSTMENTS_LIST';
export const FETCHED_STOCK_ADJUSTMENTS_LIST = '@@toyota/FETCHED_STOCK_ADJUSTMENTS_LIST';
export const FETCHED_STOCK_ADJUSTMENTS_LIST_FAILED = '@@toyota/FETCHED_STOCK_ADJUSTMENTS_LIST_FAILED';


// description Mantain
export const FETCHING_DESCRIPTION_MANTAIN_SA_LIST = '@@toyota/FETCHING_DESCRIPTION_MANTAIN_SA_LIST';
export const FETCHED_DESCRIPTION_MANTAIN_SA_LIST = '@@toyota/FETCHED_DESCRIPTION_MANTAIN_SA_LIST';
export const FETCHED_DESCRIPTION_MANTAIN_SA_LIST_FAILED = '@@toyota/FETCHED_DESCRIPTION_MANTAIN_SA_LIST_FAILED';


export const ADDING_DESCRIPTION_MANTAIN_SA_LIST = '@@toyota/ADDING_DESCRIPTION_MANTAIN_SA_LIST';
export const ADDED_DESCRIPTION_MANTAIN_SA_LIST = '@@toyota/ADDED_DESCRIPTION_MANTAIN_SA_LIST';
export const ADDED_DESCRIPTION_MANTAIN_SA_LIST_FAILED = '@@toyota/ADDED_DESCRIPTION_MANTAIN_SA_LIST_FAILED';


export const UPDATING_DESCRIPTION_MANTAIN_SA_LIST = '@@toyota/UPDATING_DESCRIPTION_MANTAIN_SA_LIST';
export const UPDATED_DESCRIPTION_MANTAIN_SA_LIST = '@@toyota/UPDATED_DESCRIPTION_MANTAIN_SA_LIST';
export const UPDATED_DESCRIPTION_MANTAIN_SA_LIST_FAILED = '@@toyota/UPDATED_DESCRIPTION_MANTAIN_SA_LIST_FAILED';

export const REMOVING_DESCRIPTION_MANTAIN_SA_LIST = '@@toyota/REMOVING_DESCRIPTION_MANTAIN_SA_LIST';
export const REMOVED_DESCRIPTION_MANTAIN_SA_LIST = '@@toyota/REMOVED_DESCRIPTION_MANTAIN_SA_LIST';
export const REMOVED_DESCRIPTION_MANTAIN_SA_LIST_FAILED =
'@@toyota/REMOVED_DESCRIPTION_MANTAIN_SA_LIST_FAILED';
